import React, { Component, version } from "react";
import {
  Row,
  Col,
  Icon,
  Form,
  Select,
  Upload,
  Button,
  Input,
  InputNumber,
  Spin,
} from "antd";
import BraftEditor from "braft-editor";
import { ContentUtils } from "braft-utils";
import "braft-editor/dist/index.css";
import PropTypes from "prop-types";
import { app, config, api } from "../../../app";

const Option = Select.Option;
const FormItem = Form.Item;
const TextArea = Input.TextArea;

/**
 * 上传之前
 * @param file
 */
function beforeUpload(file) {
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    app.alert("图片最大2MB！", "error");
    return Promise.reject(false);
  }
  return Promise.resolve(true);
}

/**
 * 上传之前2
 * @param file
 */
function beforeUpload2(file) {
  const isLt2M = file.size / 1024 / 1024 < 2,
    types = ["image/png", "image/jpeg", "image/gif", "image/webp"];
  if (!isLt2M) {
    app.alert("图片最大2MB！", "error");
    return Promise.reject(false);
  } else if (types.indexOf(file.type) === -1) {
    app.alert("仅支持上传【.png, .jpg, .gif】！", "error");
    return Promise.reject(false);
  }

  return Promise.resolve(true);
}

class NewsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      levelList: [],
      PositionList: [],
      teamList:[],
      objList: [],
      editData: {},
      detailData: {},
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.Enterprise();
    await this.getteamList();
    if (this.props.edit_id) {
      await this.handleDetailData(this.props.edit_id);
    }

    // await this.handleNewsLevelData()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 打开详情
   */
  handleDetailData = async (id) => {
    await this.setData({ detail_loading: true });
    let { detailData } = this.state;
    let { flag, data, msg } = await app.post(api.companyDetails, {
      company_id: id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    });
    if (flag !== 1) {
      app.alert(msg, "error");
    }
    detailData = data;
    this.props.form.setFieldsValue({
      company_img: [
        {
          uid: "-1",
          name: "门面照.png",
          status: "done",
          response: {
            flag: 1,
            data: { url: data.company_img },
          },
          url: config.imgUrl + data.company_img,
        },
      ],
    });
    this.setData({ detailData });
    // await app.sleep(2000);
    console.log(this.state.detailData);
    await this.setData({ detail_loading: false });
  };

  /**
   * 编辑器图片上传
   * @param file
   * @returns {boolean}
   */
  editorUploadHandler = ({ file }) => {
    if (!file) {
      return false;
    }
    if (file.status === "done" && file.response && file.response.flag === 1) {
      this.props.form.setFieldsValue({
        news_content: ContentUtils.insertMedias(
          this.props.form.getFieldValue("news_content"),
          [
            {
              type: "IMAGE",
              url: config.imgUrl + file.response.data.url,
            },
          ]
        ),
      });
    } else if (file.status === "error") {
      app.alert("上传失败", "error");
    }
  };

  /**
   * 预览
   */
  handlePreview = () => {
    const html = this.props.form.getFieldValue("news_content").toHTML();
    console.log(html);
    if (!html || html === "<p></p>") {
      app.alert("您填写内容后才可预览！", "warn");
      return;
    }
    if (window.previewWindow) {
      window.previewWindow.close();
    }
    window.previewWindow = window.open();
    window.previewWindow.document.write(html);
    window.previewWindow.document.close();
  };

  /**
   * 预览HTML
   **/
  buildPreviewHtml = (html) => {
    return `
              <!Doctype html>
              <html>
                <head>
                  <title>预览内容</title>
                  <style>
                    html,body{
                      height: 100%;
                      margin: 0;
                      padding: 0;
                      overflow: auto;
                      background-color: #f1f2f3;
                    }
                    .container{
                      box-sizing: border-box;
                      width: 1000px;
                      max-width: 100%;
                      min-height: 100%;
                      margin: 0 auto;
                      padding: 30px 20px;
                      overflow: hidden;
                      background-color: #fff;
                      border-right: solid 1px #eee;
                      border-left: solid 1px #eee;
                    }
                    .container img,
                    .container audio,
                    .container video{
                      max-width: 100%;
                      height: auto;
                    }
                    .container p{
                      white-space: pre-wrap;
                      min-height: 1em;
                    }
                    .container pre{
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-radius: 5px;
                    }
                    .container blockquote{
                      margin: 0;
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-left: 3px solid #d1d1d1;
                    }
                  </style>
                </head>
                <body>
                  <div class="container">${html}</div>
                </body>
              </html>
            `;
  };

  /**
   * 提交
   **/
  handleAdd = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        await this.setData({ submit_loading: false });
        if (
          values.company_img &&
          values.company_img[0] &&
          values.company_img[0].response &&
          values.company_img[0].response.flag === 1
        ) {
          if (values.company_img.length > 1) {
            values.company_img = values.company_img
              .map(function(img) {
                return img.response.data.url;
              })
              .join(":::");
          } else {
            values.company_img = values.company_img[0].response.data.url;
          }
        }
        values.indexno = app.getData("indexno");
        values.account = app.getData("account");
        const { edit_id } = this.props;
        let result = {};
        if (edit_id) {
          values.company_id = edit_id;
          result = await app.post(api.companyEdit, values);
        } else {
          result = await app.post(api.companyAdd, values);
        }
        if (result.flag === 1) {
          app.alert("提交成功", "success");
          this.props.onClose(true);
        } else {
          app.alert(result.msg || "提交失败", "error");
        }
      }
    });
  };

  /**
   * 获取宣传级别
   * @returns {Promise<void>}
   */
  handleNewsLevelData = async () => {
    let params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.Newslevel, params);
    if (flag !== 1) {
      data = [];
      app.alert(msg, "error");
    }
    await this.setData({ levelList: data });
  };

// 所属队伍
  getteamList = async () =>{
    let params = {
      account: app.getData("account"),
    },
    { flag, data, msg } = await app.post(api.getTeamName, params);
  if (flag === 1) {
    this.setData({ teamList: data });
  } else {
    app.alert(msg, "error");
    return {};
  }
  }
  
  // 企业类型
  Enterprise = async () => {
    let params = {
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.companyClassList, params);
    if (flag === 1) {
      this.setData({ PositionList: data });
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  /**
   * 获取宣传对象
   * @returns {Promise<void>}
   */
  handleNewsObjectData = async (level) => {
    if (level && level === "1") return;
    await this.setData({ obj_loading: true });
    this.props.form.setFieldsValue({ object: undefined });
    let params = {
        level,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.NewsReleaseObject, params);
    if (flag !== 1) {
      data = [];
      app.alert(msg, "error");
    }
    await this.setData({ objList: data, obj_loading: false });
  };

  render() {
    let formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      { edit_id } = this.props,
      { getFieldDecorator, getFieldsValue } = this.props.form,
      {
        levelList,
        obj_loading,
        objList,
        detail_loading,
        editData,
        detailData,
        submit_loading,
        PositionList,
        teamList,
        isDo,
      } = this.state,
      formData = getFieldsValue(["company_img", "object_type"]);
    const excludeControls = ["media", "emoji", "code"],
      extendControls = [
        {
          key: "custom-button",
          type: "button",
          text: "预览",
          onClick: this.handlePreview,
        },
        {
          key: "antd-uploader",
          type: "component",
          component: (
            <Upload
              accept="image/png,image/jpeg,image/gif"
              showUploadList={false}
              action={config.serverUrl + api.ImageUpload}
              beforeUpload={beforeUpload2}
              data={{
                token: app.getData("token"),
                indexno: app.getData("indexno"),
                account: app.getData("account"),
                upload_type: "news",
              }}
              name="image"
              onChange={(file) => this.editorUploadHandler(file)}
            >
              {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
              <button
                type="button"
                className="control-item button upload-button"
                data-title="插入图片"
              >
                <Icon type="picture" theme="filled" />
              </button>
            </Upload>
          ),
        },
      ];
    return (
      <div>
        {detail_loading ? (
          <div style={{ textAlign: "center" }}>
            <Spin size="large" />
          </div>
        ) : null}
        <Form onSubmit={this.handleAdd} hidden={detail_loading}>
        <FormItem {...formItemLayout} label="所属队伍">
            {getFieldDecorator("team_id", {
              rules: [
                {
                  required: true,
                  message: "请选择所属队伍",
                },
              ],
              initialValue: detailData.team_id,
            })(
              <Select disabled={isDo} size="large" placeholder="请选择所属队伍">
                {teamList.length > 0 &&
                  teamList.map((item, index) => (
                    <Option key={item.team_id} value={item.team_id}>
                      {item.teamname}
                    </Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="门面照">
            {getFieldDecorator("company_img", {
              rules: [
                {
                  required: true,
                  message: "请上传门面照！",
                },
              ],
              valuePropName: "fileList",
              getValueFromEvent: (e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e && e.fileList;
              },
              initialValue: [],
            })(
              <Upload
                accept="image/jpeg, image/jpg, image/png"
                action={config.serverUrl + api.ImageUpload}
                // disabled={formData.news_img && formData.news_img.length >= 1}
                beforeUpload={beforeUpload}
                data={{
                  token: app.getData("token"),
                  indexno: app.getData("indexno"),
                  account: app.getData("account"),
                  upload_type: "mall",
                }}
                name="image"
                listType="picture"
                showUploadList={true}
                className="upload-list-inline"
              >
                <Button
                  disabled={
                    formData.company_img && formData.company_img.length >= 1
                  }
                >
                  <Icon type="upload" /> 点击上传
                </Button>
                <span style={{ color: "red" }}>最多可上传1 张图片</span>
              </Upload>
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="企业类型">
            {getFieldDecorator("class_id", {
              rules: [
                {
                  required: true,
                  message: "请选择企业类型",
                },
              ],
              initialValue: detailData.class_id,
            })(
              <Select disabled={isDo} size="large" placeholder="请选择企业类型">
                {PositionList.length > 0 &&
                  PositionList.map((item, index) => (
                    <Option key={item.class_id} value={item.class_id}>
                      {item.class_name}
                    </Option>
                  ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="企业名称" {...formItemLayout}>
            {getFieldDecorator("company_name", {
              rules: [{ required: true, message: "请输入企业名称！" }],
              initialValue: detailData.company_name || "",
            })(<Input placeholder="请填写" disabled={isDo} />)}
          </FormItem>
          <FormItem label="联系人" {...formItemLayout}>
            {getFieldDecorator("linkman", {
              rules: [{ required: true, message: "请输入联系人！" }],
              initialValue: detailData.linkman || "",
            })(<Input placeholder="请填写" disabled={isDo} />)}
          </FormItem>
          <FormItem label="联系方式" {...formItemLayout}>
            {getFieldDecorator("linkman_mobile", {
              rules: [{ required: true, message: "请输入联系方式！" }],
              initialValue: detailData.linkman_mobile || "",
            })(
              <InputNumber
                style={{ width: "100%" }}
                placeholder="请填写"
                disabled={isDo}
              />
            )}
          </FormItem>
          <FormItem label="企业爱心值" {...formItemLayout}>
            {getFieldDecorator("love_value", {
              rules: [{ required: true, message: "请输入企业爱心值！" }],
              initialValue: detailData.love_value || "",
            })(
              <InputNumber
                style={{ width: "50%" }}
                placeholder="请填写"
                disabled={isDo}
              />
            )}
            <span style={{ color: "red" }}>爱心值越大，排名越向前</span>
          </FormItem>
          <FormItem label="企业地址" {...formItemLayout}>
            {getFieldDecorator("location", {
              rules: [{ required: true, message: "企业地址必填！" }],
              initialValue: detailData.location || "",
            })(
              <TextArea
                placeholder="请输入企业地址"
                autoSize={{ maxRows: 3, minRows: 2 }}
                disabled={isDo}
              />
            )}
          </FormItem>
          <FormItem label="企业简介" {...formItemLayout}>
            {getFieldDecorator("recommend", {
              rules: [{ required: true, message: "企业简介必填！" }],
              initialValue: detailData.recommend || "",
            })(
              <TextArea
                placeholder="请输入企业简介"
                autoSize={{ maxRows: 5, minRows: 4 }}
                disabled={isDo}
              />
            )}
          </FormItem>
          <FormItem wrapperCol={{ span: 12, offset: 6 }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: "0 20px" }}
              loading={submit_loading}
            >
              提交
            </Button>
          </FormItem>
          {/* <Row>
            <Col offset={3} span={3}>
              <Button size="large" type="primary" htmlType="submit" block>
                提交
              </Button>
            </Col>
          </Row> */}
        </Form>
      </div>
    );
  }
}

NewsAdd.propTypes = {
  edit_id: PropTypes.any,
};

export default Form.create()(NewsAdd);



// WEBPACK FOOTER //
// ./src/routes/grade/Enterprise/enterpriseAdd.jsx